<template>
  <div>
    <div class="history-box" v-for="(group, index) in history" :key="index" v-show="Object.keys(history).length && !loading">
      <div class="head" @click="toggle(index)">
        <div class="icon">
          <i class="fa fa-minus-circle" v-if="open.indexOf(index) > -1"></i>
          <i class="fa fa-plus-circle" v-else></i>
        </div>
        <div class="info">
          <div class="doc-type" v-if="index != 'W-9'">{{ renameDocument(index) }}</div>
          <div class="doc-type" v-else>W-9 Form</div>
        </div>
      </div>
      

      <transition name="slide-down">
        <div v-show="open.indexOf(index) > -1">
          <div class="body">
            <table class="desktopTable">
              <thead>
                <th>Replaced On</th>
                <th v-if="index === 'Insurance Policy'">Insurance Company Name</th>
                <th v-if="index === 'Insurance Policy'">Insurance Policy #</th>
                <th v-if="index === 'City License'">City License #</th>
                <th v-if="index === 'TCP Permit'">TCP Permit #</th>
                <th v-if="index === 'Airport Permit'">Airport Permit #</th>
                <th v-if="index === 'Driver\'s License'">Driver's License #</th>
                <th v-if="index === 'Vehicle Safety Inspection'">Inspection Performed By</th>
                <th v-if="['SSN', 'EIN', 'W-9'].indexOf(index) === -1">Expiration Date</th>
                <th>File</th>
              </thead>
              <tbody>
                <tr v-for="data in group" :key="data.id">
                  <td>{{ formatDate(data.replacedOn) }}</td>
                  <td v-if="data.document === 'Insurance Policy'">{{ data.company }}</td>
                  <td v-if="data.document === 'Vehicle Safety Inspection'">{{ data.by }}</td>
                  <td v-if="['Driving Record', 'Vehicle Safety Inspection', 'SSN', 'EIN', 'W-9', 'Vehicle Registration', 'Background Check'].indexOf(data.document) === -1">{{ data.number }}</td>
                  <td v-if="['SSN', 'EIN', 'W-9'].indexOf(data.document) === -1">{{ data.expire }}</td>
                  <td><a :href="data.file" target="_blank">View attached file</a></td>
                </tr>
              </tbody>
            </table>

            <div class="mobileTable">
              <div class="cards">
                <div class="card" v-for="data in group" :key="data.id">
                  <div class="data">
                    <div class="title">Replaced On: </div>
                    <div class="value">{{ formatDate(data.replacedOn) }}</div>
                  </div>
                  <div class="data" v-if="data.document === 'Insurance Policy'">
                    <div class="title">Insurance Company Name: </div>
                    <div class="value">{{ data.company }}</div>
                  </div>
                  <div class="data" v-if="data.document === 'Vehicle Safety Inspection'">
                    <div class="title">Inspection Performed By: </div>
                    <div class="value">{{ data.by }}</div>
                  </div>
                  <div class="data" v-if="['Driving Record', 'Vehicle Safety Inspection', 'SSN', 'EIN', 'W-9', 'Vehicle Registration', 'Background Check'].indexOf(data.document) === -1">
                    <div class="title" v-if="index === 'Insurance Policy'">Insurance Policy #</div>
                    <div class="title" v-if="index === 'City License'">City License #</div>
                    <div class="title" v-if="index === 'TCP Permit'">TCP Permit #</div>
                    <div class="title" v-if="index === 'Airport Permit'">Airport Permit #</div>
                    <div class="title" v-if="index === 'Driver\'s License'">Driver's License #</div>
                    <div class="value">{{ data.number }}</div>
                  </div>
                  <div class="data" v-if="['SSN', 'EIN', 'W-9'].indexOf(data.document) === -1">
                    <div class="title">Expiration Date: </div>
                    <div class="value">{{ data.expire }} - {{data.document}}</div>
                  </div>
                  <div class="link">
                    <i class="fas fa-paperclip"></i>
                    <a :href="data.file" target="_blank">View attached file</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div class="history-box empty" v-show="loading">
      <ellipsis-loader></ellipsis-loader>
      <span>Getting document history...</span>
    </div>

    <div class="history-box empty" v-show="!Object.keys(history).length && !loading">
      <i class="fa fa-list-alt fa-2x"></i>
      <span>No document history as of yet.</span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import EllipsisLoader from '@/components/Partials/LoadingAnimation/Ellipsis'

export default {
  name: 'doc-history',
  props: ['active'],
  data () {
    return {
      loading: false,
      history: {},
      open: [],
      loaded: ''
    }
  },
  components: { EllipsisLoader },
  computed: {
    provId () { return this.$route.params.id },
  },
  methods: {
    init () {
      let self = this
      if (self.loading) { return }
      self.history = {}
      self.open = []

      self.loading = true
      self.$sdk.get('/provider/' + this.provId + '/dochistory', {
        token: this.$store.state.session.sessionToken,
      }, res => {
        self.loading = false
        if (!res.error) {
          res.list.forEach(data => {
            if (!self.history[data.document] && data.file) {
              self.history[data.document] = []
              self.open.push(data.document)
            }

            if (data.file) {
              self.history[data.document].push(data)
            }
          })

          // Rearrange object
          let tempObj = {}
          if (self.history['Insurance Policy']) {
            tempObj['Insurance Policy'] = self.history['Insurance Policy']
          }
          if (self.history['City License']) {
            tempObj['City License'] = self.history['City License']
          }
          if (self.history['TCP Permit']) {
            tempObj['TCP Permit'] = self.history['TCP Permit']
          }
          if (self.history['Airport Permit']) {
            tempObj['Airport Permit'] = self.history['Airport Permit']
          }
          if (self.history['Driver\'s License']) {
            tempObj['Driver\'s License'] = self.history['Driver\'s License']
          }
          if (self.history['Vehicle Safety Inspection']) {
            tempObj['Vehicle Safety Inspection'] = self.history['Vehicle Safety Inspection']
          }
          if (self.history['Driving Record']) {
            tempObj['Driving Record'] = self.history['Driving Record']
          }
          if (self.history['W-9']) {
            tempObj['W-9'] = self.history['W-9']
          }
          if (self.history['SSN']) {
            tempObj['SSN'] = self.history['SSN']
          }
          if (self.history['Vehicle Registration']) {
            tempObj['Vehicle Registration'] = self.history['Vehicle Registration']
          }
          if (self.history['Background Check']) {
            tempObj['Background Check'] = self.history['Background Check']
          }
          self.history = tempObj

          self.$nextTick().then(() => {
            self.$forceUpdate()
          })
          // self.history = res.list
        }
      })
    },
    toggle (id) {
      if (this.open.indexOf(id) > -1) {
        this.open.splice(this.open.indexOf(id), 1)
      } else {
        this.open.push(id)
      }
    },
    formatDate (val) { return val ? moment(val, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY hh:mm:ss A') : '' },
    renameDocument (x) {
      switch (x) {
        case 'Driving Record': return 'Background Check'
        default: return x
      }
    }
  },
  watch: {
    provId (value) {
      if (this.active && this.loaded !== value) {
        this.loaded = this.provId
        this.init()
      }
    },
    active (val) {
      if (val && this.loaded !== this.provId) {
        this.loaded = this.provId
        this.init()
      }
    }
  },
  mounted () {
    // this.init()
  }
}
</script>

<style lang="scss" scoped>
.date-group{
  text-align: center;
  font-size: 24px;
  color: #0D79F2;
  margin: 25px auto 5px;
  position: relative;
  width: 90%;

  &:after{
    content: ' ';
    width: 100%;
    position: absolute;
    top: 50%;
    border-top: 1px solid #ccc;
    left: 0;
    z-index: 1;
  }
  span{
    position: relative;
    background: #ededed;
    z-index: 2;
    padding: 0 20px;
  }
}
.history-box{
  background-color: #fff;
  padding: 15px;
  border-radius: 3px;
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  margin: 0 auto 10px;
  width: 90%;

  .head{
    cursor: pointer;

    .icon{
      float:left;
      width: 35px;
      color: #0D79F2;
      
      i{ font-size: 24px; }
    }
    .info{
      width: calc(100% - 30px);
    }
    .doc-type{
      font-weight: 600;
      color: #0D79F2;
    }
  }
  .body{
    padding: 10px;
    font-size: 13px;
    border-radius: 4px;
    margin: 10px 0 0;

    .label{
      text-align: right;
      color: #606060;
      width: 170px;
    }
    .value{
      padding-left: 8px;
      font-weight: 600;
      color: #333;
    }
  }
  &.empty{
    text-align: center;
    padding: 40px; 
    i{
      color: #ccc;
      margin-bottom: 5px;
    }
    span{
      display: block;
      font-size: 24px;
      font-weight: 600;
      color:#777;
      font-style: italic;
    }
  }
}

table{
  border-collapse: collapse;
  width: 100%;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{
      padding: 5px 10px;

      &:last-child{ cursor: default; }
      i{ display: none; }
      & i.stripe-icon { display: inline; }
      .fa-sort-up{ vertical-align: -2px; }
      .fa-sort-down{ vertical-align: 2px; }
      &.sortable{
        cursor: pointer;
        color: #333;
        span{
          font-weight: 600;
          text-decoration: underline;
        }
      }
      &.sort i{ display: inline-block; }
    }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      &:nth-child(even) { background: #f3f3f3; }
      &:hover { background: #d7dbe4; }
      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        color: #555;

        &.status, &.bookedThrough{ font-weight: 600; }
        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
        a{
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .2s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.mobileTable {
  display: none;
}

@media only screen and (max-width: 430px) {
  .desktopTable {
    display: none;
  }
  .mobileTable {
    display: block;
  }
  .cards {
    .card {
      border: 1px solid #ccc;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;
      display: flex;
      flex-direction: column;

      .info {
        width: 100%;
        padding-left: 10px;
      }

      > div {
        margin-bottom: 3px;
        width: 100%;
      }
      .data {
        display: flex;
        align-items: center;
        margin-bottom: 3px;
      }


      .title {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        padding: 0;
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
        i {
          color: #bbb;
        }
        a {
          text-decoration: none;
        }
      }

      .link {
        i {
          color: #bbb;
        }
        font-weight: 900;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Provider/DocHistory.vue